import React from 'react';

export const ShoppingCartAdd = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--shopping-cart-add';
  color = color || '#0076CC';

  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M1 4H3L3.4 6L5 14M5 14H15L19 6M5 14L2.70711 16.2929C2.07714 16.9229 2.52331 18 3.41421 18H15M15 18C13.8954 18 13 18.8954 13 20C13 21.1046 13.8954 22 15 22C16.1046 22 17 21.1046 17 20C17 18.8954 16.1046 18 15 18ZM7 20C7 21.1046 6.10457 22 5 22C3.89543 22 3 21.1046 3 20C3 18.8954 3.89543 18 5 18C6.10457 18 7 18.8954 7 20Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 6.09998L11 9.09998L8 6.09998"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11 8V1" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};

export default ShoppingCartAdd;
